import {useState} from 'react';

export function useOpenDialogState(){
    const [isPopOverOpen, set] = useState(false);
    const togglePopOverAction = () => {
        set(!isPopOverOpen);
    };
    const onTipHide = () => {
        if (isPopOverOpen){
            togglePopOverAction();
        }
    };
    return [isPopOverOpen, togglePopOverAction, onTipHide];
}

